import React from "react";
import { FormControl, Col, Row, Card } from "react-bootstrap";
import {
  FaFilter,
  FaMoneyBillAlt,
  FaArrowLeft,
  FaArrowRight,
  FaEllipsisV,
} from "react-icons/fa";

class wages extends React.Component {
  state = {
    filterValue: "Luboš Fridrich, 2022",
  };

  componentDidMount() {
    this.props.setHeaderPage({
      Icon: <FaMoneyBillAlt className="c-placeholder c-green" />,
      Title: "Mzdy",
      SubTitle: "",
    });
  }

  render() {
    return (
      <>
        <div class="p-3 mb-4 bg-uni rounded">
          <div class="d-flex justify-content-between align-items-start align-items-md-center">
            <div>
              <span class="text-secondary mr-1 me-2">Použité filtry:</span>
              <span>
                <strong>
                  {this.state.filterValue == "" ? "" : this.state.filterValue}
                </strong>
              </span>
            </div>
            <Col xs={4} className="d-flex justify-content-end">
              <FaFilter className="cursor-pointer" />
            </Col>
          </div>
        </div>

        
        <Row className="mb-4">
          <Col className="d-flex justify-content-between align-items-center">
            <span>
              <FaArrowLeft className="me-4 cursor-pointer" />
              <strong className="me-4">2022</strong>{" "}
              <FaArrowRight className="cursor-pointer" />
            </span>
            <span>Luboš Fridrich</span>
          </Col>
        </Row>
        <Row className="mb-2">
          <Col>
            <Card className="bg-white">
              <Row className="mt-1 mb-1 ms-1 me-1">
                <Col xs={1}>
                  <Row>
                    <strong>01</strong>
                  </Row>
                  <Row>
                    <small>Leden</small>
                  </Row>
                </Col>
                <Col
                  xs={7}
                  className="d-flex justify-content-start align-items-center"
                >
                  <strong>{new Date().toLocaleString('default', { month: 'long' })}</strong>
                </Col>
                <Col xs={3}>
                  <Row>
                    <small className="c-black">10264 CZK</small>
                  </Row>
                  <Row>
                    <small className="c-green">2541 CZK</small>
                  </Row>
                </Col>
                <Col
                  xs={1}
                  className="d-flex justify-content-end align-items-center"
                >
                  <FaEllipsisV className="cursor-pointer" />
                </Col>
              </Row>
            </Card>
          </Col>
        </Row>
        <Row>
          <Col>
            <Card className="bg-white">
              <Row className="mt-1 mb-1 ms-1 me-1">
                <Col xs={1}>
                  <Row>
                    <strong>02</strong>
                  </Row>
                  <Row>
                    <small>Únor</small>
                  </Row>
                </Col>
                <Col
                  xs={7}
                  className="d-flex justify-content-start align-items-center"
                >
                  <strong>Poček dokončených zakázek: 120</strong>
                </Col>
                <Col xs={3}>
                  <Row>
                    <small className="c-black">10264 CZK</small>
                  </Row>
                  <Row>
                    <small className="c-green">2541 CZK</small>
                  </Row>
                </Col>
                <Col
                  xs={1}
                  className="d-flex justify-content-end align-items-center"
                >
                  <FaEllipsisV className="cursor-pointer" />
                </Col>
              </Row>
            </Card>
          </Col>
        </Row>
      </>
    );
  }
}

export default wages;
